var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRateStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8473 2.50988C11.5966 0.203878 14.8589 0.203878 15.6082 2.50988L16.8804 6.42535C17.2155 7.45663 18.1765 8.15486 19.2609 8.15486H23.3779C25.8025 8.15486 26.8107 11.2576 24.8491 12.6828L21.5184 15.1026C20.6411 15.74 20.274 16.8698 20.6091 17.901L21.8813 21.8165C22.6306 24.1225 19.9913 26.0401 18.0297 24.6149L14.699 22.195C13.8217 21.5576 12.6338 21.5576 11.7566 22.195L8.42585 24.6149C6.46425 26.0401 3.82493 24.1225 4.5742 21.8165L5.84641 17.901C6.18149 16.8698 5.81441 15.74 4.93716 15.1026L1.60645 12.6828C-0.355148 11.2576 0.652981 8.15486 3.07766 8.15486H7.19463C8.27898 8.15486 9.24 7.45663 9.57509 6.42536L10.8473 2.50988Z",
    fill: "#FFD15B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRateStar);
export default __webpack_public_path__ + "static/media/rateStar.191d93c6729d97599203060e93f350f8.svg";
export { ForwardRef as ReactComponent };